"use client";

import { faPhone } from "@fortawesome/pro-solid-svg-icons";
import { SquareButton, usePageVariantContext } from "@tosize/ui";
import { getConstants, getLocaleConstants } from "@tosize/ui";
import type { ReactNode } from "react";
import { StyledLink } from "~/components/Link";

interface CallButtonProps {
	lang: string;
	className?: string;
	isBusinessCustomer: boolean;
	parent?: ReactNode;
	children?: ReactNode;
	icon?: boolean | null;
}

export function CallButton(props: CallButtonProps) {
	const { lang, className, isBusinessCustomer = false, parent, children, icon = true } = props;

	const constants = getConstants();
	const localeConstants = getLocaleConstants(lang);

	const phone = isBusinessCustomer
		? {
				title: constants.customerService.businessPhone.replaceAll(" ", "\u00A0"),
				href: `tel:${constants.customerService.businessPhoneHtml.replaceAll(" ", "")}`,
			}
		: {
				title: constants.customerService.phone.replaceAll(" ", "\u00A0"),
				href: `tel:${constants.customerService.phoneHtml.replaceAll(" ", "")}`,
			};

	if (!(phone && localeConstants.customerServicePhone)) {
		return null;
	}

	return (
		<>
			{parent}
			<StyledLink className={className} starticon={icon ? faPhone : undefined} href={phone.href}>
				{children} {phone.title}
			</StyledLink>
		</>
	);
}

export function CallButtonHeader(props: Pick<CallButtonProps, "lang" | "isBusinessCustomer">) {
	const { lang, isBusinessCustomer = false } = props;

	const constants = getConstants();
	const localeConstants = getLocaleConstants(lang);
	const { variant } = usePageVariantContext();

	const phone = isBusinessCustomer
		? {
				title: constants.customerService.businessPhone.replaceAll(" ", "\u00A0"),
				href: `tel:${constants.customerService.businessPhoneHtml.replaceAll(" ", "")}`,
			}
		: variant === "tosize_furniture"
			? {
					title: constants.customerService.phone.replaceAll(" ", "\u00A0"),
					href: `tel:${constants.customerService.phoneHtml.replaceAll(" ", "")}`,
				}
			: null;

	if (!(phone && localeConstants.customerServicePhone)) {
		return null;
	}

	return (
		<>
			<SquareButton
				component="a"
				href={phone.href}
				title={phone.title}
				icon={faPhone}
				color="shades"
				className="xs:flex hidden xl:hidden"
			/>
			<StyledLink
				className="hidden whitespace-nowrap xl:inline"
				starticon={faPhone}
				href={phone.href}
			>
				{phone.title}
			</StyledLink>
		</>
	);
}
